import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 2.25C4.48122 2.25 3.25 3.48122 3.25 5C3.25 5.41421 3.58579 5.75 4 5.75C4.41421 5.75 4.75 5.41421 4.75 5C4.75 4.30964 5.30964 3.75 6 3.75H18C18.6904 3.75 19.25 4.30964 19.25 5V19C19.25 19.6904 18.6904 20.25 18 20.25H6C5.30964 20.25 4.75 19.6904 4.75 19C4.75 18.5858 4.41421 18.25 4 18.25C3.58579 18.25 3.25 18.5858 3.25 19C3.25 20.5188 4.48122 21.75 6 21.75H18C19.5188 21.75 20.75 20.5188 20.75 19V5C20.75 3.48122 19.5188 2.25 18 2.25H6Z"
        fill={colorValue}
      />
      <path
        d="M3 7.25C2.58579 7.25 2.25 7.58579 2.25 8C2.25 8.41421 2.58579 8.75 3 8.75H5C5.41421 8.75 5.75 8.41421 5.75 8C5.75 7.58579 5.41421 7.25 5 7.25H3Z"
        fill={colorValue}
      />
      <path
        d="M3 11.25C2.58579 11.25 2.25 11.5858 2.25 12C2.25 12.4142 2.58579 12.75 3 12.75H5C5.41421 12.75 5.75 12.4142 5.75 12C5.75 11.5858 5.41421 11.25 5 11.25H3Z"
        fill={colorValue}
      />
      <path
        d="M3 15.25C2.58579 15.25 2.25 15.5858 2.25 16C2.25 16.4142 2.58579 16.75 3 16.75H5C5.41421 16.75 5.75 16.4142 5.75 16C5.75 15.5858 5.41421 15.25 5 15.25H3Z"
        fill={colorValue}
      />
      <path
        d="M10.4129 7.62763C10.0111 8.02949 9.78529 8.57453 9.78529 9.14286C9.78529 9.71118 10.0111 10.2562 10.4129 10.6581C10.8148 11.0599 11.3598 11.2857 11.9281 11.2857C12.4965 11.2857 13.0415 11.0599 13.4434 10.6581C13.8452 10.2562 14.071 9.71118 14.071 9.14286C14.071 8.57453 13.8452 8.02949 13.4434 7.62763C13.0415 7.22576 12.4965 7 11.9281 7C11.3598 7 10.8148 7.22576 10.4129 7.62763Z"
        fill={colorValue}
      />
      <path
        d="M9.17194 13.1212C8.43703 13.8448 8.01611 14.8283 8.00006 15.8595C7.99882 15.9289 8.01784 15.9972 8.0548 16.056C8.09176 16.1148 8.14505 16.1615 8.20815 16.1905C9.34101 16.7105 10.6015 17 11.9281 17C13.212 17.0017 14.4811 16.7256 15.6481 16.1905C15.7112 16.1615 15.7645 16.1148 15.8015 16.056C15.8385 15.9972 15.8575 15.9289 15.8562 15.8595C15.8402 14.8283 15.4193 13.8448 14.6844 13.1212C13.9494 12.3977 12.9595 11.9921 11.9281 11.9921C10.8968 11.9921 9.90686 12.3977 9.17194 13.1212Z"
        fill={colorValue}
      />
    </svg>
  );
};
